module.exports = __webpack_public_path__ + "static/media/thumbnail.18e46c6b.jpg";